import { UseToastOptions } from '@chakra-ui/react';
import { ReactComponent as AfricaIcon } from 'assets/icons/mapIcons/africa.svg';
import { ReactComponent as AsiaIcon } from 'assets/icons/mapIcons/asia.svg';
import { ReactComponent as AustraliaIcon } from 'assets/icons/mapIcons/australia.svg';
import { ReactComponent as CanadaIcon } from 'assets/icons/mapIcons/canada.svg';
import { ReactComponent as EuropeIcon } from 'assets/icons/mapIcons/europe.svg';
import { ReactComponent as UnitedKingdomIcon } from 'assets/icons/mapIcons/unitedKingdom.svg';
import { ReactComponent as UnitedStatesIcon } from 'assets/icons/mapIcons/unitedStates.svg';
import { ReactComponent as WorldIcon } from 'assets/icons/mapIcons/world.svg';
import { UserTypes } from 'modules/User';

import mapDataIndex from './MapCollection/mapDataIndex';
import { generateMapConfigs } from './MapWidgetMenu.helpers';
import { DefaultMapConfig, MapDataIndex, MapMenuButtonConfig } from './MapWidgetMenu.types';

export const DEFAULT_MAP_WIDGET_MENU_BUTTON_PERMISSION = UserTypes.Premium;

export const DEFAULT_MAPS: DefaultMapConfig[] = [
  {
    originalName: 'United States of America',
    newName: 'United States',
    newIcon: <UnitedStatesIcon />,
    newPermission: UserTypes.Free,
  },
  { originalName: 'Canada', newIcon: <CanadaIcon />, newPermission: UserTypes.Free },
  { originalName: 'Europe', newIcon: <EuropeIcon /> },
  { originalName: 'United Kingdom', newIcon: <UnitedKingdomIcon /> },
  { originalName: 'Australia', newIcon: <AustraliaIcon /> },
  { originalName: 'Asia', newIcon: <AsiaIcon /> },
  { originalName: 'Africa', newIcon: <AfricaIcon /> },
  { originalName: 'World, Miller projection, medium resolution', newName: 'World Map' },
];

// The 8 default maps: US, Canada, Europe, UK, Australia, Asia, Africa, World.
export const DEFAULT_MAP_CONFIGS: MapMenuButtonConfig[] = generateMapConfigs(
  mapDataIndex as unknown as MapDataIndex,
  DEFAULT_MAPS,
  <WorldIcon />,
  true,
);

// All maps that include the 8 default maps as well.
export const ALL_MAP_CONFIGS: MapMenuButtonConfig[] = generateMapConfigs(
  mapDataIndex as unknown as MapDataIndex,
  DEFAULT_MAPS,
  <WorldIcon />,
  false,
);

export const MAP_IMPORT_ERROR_TOAST: UseToastOptions = {
  title: 'Map import error',
  description: 'The map download is unsuccessful. Please contact our support team.',
  status: 'error',
  isClosable: true,
};

// How to obtain this? Refer to MapCollection\README.md
// Todo: Pending i18n for names
export const ALL_MAP_TITLES = [
  'Afghanistan',
  'Africa',
  'Agder',
  'Alabama',
  'Alaska',
  'Albania',
  'Alberta',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Arizona',
  'Arkansas',
  'Armenia',
  'Asia',
  'Australia',
  'Austria',
  'Auvergne-Rhône-Alpes',
  'Azerbaijan',
  'Baden-Württemberg',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Bayern',
  'Belarus',
  'Belgium',
  'Belize',
  'Benelux',
  'Benin',
  'Berlin',
  'Bhutan',
  'Bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bourgogne-Franche-Comté',
  'Brandenburg',
  'Brazil',
  'Bremen',
  'Bretagne',
  'British Columbia',
  'British Isles',
  'British Isles, admin1',
  'Brunei',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Burundi Communes',
  'California',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Canada and United States of America',
  'Canada Provinces',
  'Cape Verde',
  'Central African Republic',
  'Central America',
  'Centre-Val de Loire',
  'Chad',
  'Chile',
  'China',
  'China with Hong Kong and Macau',
  'China with Hong Kong, Macau, and Taiwan',
  'Colombia',
  'Colorado',
  'Comoros',
  'Connecticut',
  'Cook Islands',
  'Corse',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Delaware',
  'Democratic Republic of the Congo',
  'Denmark',
  'District of Columbia',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Drenthe',
  'East Timor',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Europe',
  'European Union',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'Flevoland',
  'Florida',
  'France',
  'France Regions',
  'France, mainland',
  'France, mainland admin2',
  'French Southern and Antarctic Lands',
  'Friesland',
  'Gabon',
  'Gambia',
  'Gelderland',
  'Georgia',
  'Germany',
  'Germany Bundesländer',
  'Ghana',
  'Grand-Est',
  'Greece',
  'Greenland',
  'Grenada',
  'Groningen',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guinea',
  'Guinea Bissau',
  'Guyana',
  'Guyane française',
  'Haiti',
  'Hamburg',
  'Hauts-de-France',
  'Hawaii',
  'Hessen',
  'Honduras',
  'Hungary',
  'Iceland',
  'Idaho',
  'Île-de-France',
  'Illinois',
  'India',
  'India with Andaman and Nicobar',
  'India with disputed territories',
  'Indiana',
  'Indonesia',
  'Innlandet',
  'Iowa',
  'Iran',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  'Ivory Coast',
  'Jamaica',
  'Japan',
  'Jordan',
  'Kansas',
  'Kazakhstan',
  'Kentucky',
  'Kenya',
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Limburg',
  'Lithuania',
  'Louisiana',
  'Luxembourg',
  'Macedonia',
  'Madagascar',
  'Maine',
  'Malawi',
  'Malaysia',
  'Mali',
  'Malta',
  'Manitoba',
  'Martinique',
  'Maryland',
  'Massachusetts',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mecklenburg-Vorpommern',
  'Mexico',
  'Michigan',
  'Middle East',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montana',
  'Montenegro',
  'Møre og Romsdal',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nebraska',
  'Nepal',
  'Netherlands',
  'Netherlands Provinces',
  'Nevada',
  'New Brunswick',
  'New Caledonia',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'New Zealand',
  'Newfoundland and Labrador',
  'Nicaragua',
  'Niedersachsen',
  'Niger',
  'Nigeria',
  'Noord-Brabant',
  'Noord-Holland',
  'Nordic Countries',
  'Nordic Countries without Greenland, Svalbard, and Jan Mayen',
  'Nordland',
  'Nordrhein-Westfalen',
  'Normandie',
  'North America',
  'North America without central',
  'North Atlantic Treaty Organization',
  'North Carolina',
  'North Dakota',
  'North Korea',
  'Northern Mariana Islands',
  'Northwest Territories',
  'Norway',
  'Norway Counties',
  'Norway with Svalbard and Jan Mayen',
  'Nouvelle-Aquitaine',
  'Nova Scotia',
  'Nunavut',
  'Occitanie',
  'Oceania',
  'Ohio',
  'Oklahoma',
  'Oman',
  'Ontario',
  'Oregon',
  'Oslo',
  'Overijssel',
  'Pakistan',
  'Palau',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Pays-de-la-Loire',
  'Pennsylvania',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Prince Edward Island',
  'Provence-Alpes-Côte-d’Azur',
  'Puerto Rico',
  'Puerto Rico all',
  'Qatar',
  'Quebec',
  'Republic of Serbia',
  'Republic of the Congo',
  'Réunion',
  'Rheinland-Pfalz',
  'Rhode Island',
  'Rogaland',
  'Romania',
  'Russia',
  'Russia with disputed territories',
  'Rwanda',
  'Saarland',
  'Sachsen',
  'Sachsen-Anhalt',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saskatchewan',
  'Saudi Arabia',
  'Scandinavia',
  'Schleswig-Holstein',
  'Senegal',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'Somaliland',
  'South Africa',
  'South America',
  'South Carolina',
  'South Dakota',
  'South Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Sudan with disputed territories',
  'Suriname',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syria',
  'Taiwan',
  'Tajikistan',
  'Tennessee',
  'Texas',
  'Thailand',
  'The Bahamas',
  'Thüringen',
  'Togo',
  'Trinidad and Tobago',
  'Troms og Finnmark',
  'Trøndelag',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United Kingdom countries',
  'United Republic of Tanzania',
  'United States', // The original name was `United States of America`, but for search suggestions we keep it as `United States`.
  'United States of America with Territories',
  'United States of America, mainland',
  'United States Virgin Islands',
  'Uruguay',
  'Utah',
  'Utrecht',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vermont',
  'Vestfold og Telemark',
  'Vestland',
  'Vietnam',
  'Viken',
  'Virginia',
  'Wallis and Futuna',
  'Washington',
  'West Virginia',
  'Western Sahara',
  'Wisconsin',
  'World continents',
  'World with Palestine areas, high resolution',
  'World with Palestine areas, low resolution',
  'World with Palestine areas, medium resolution',
  'World, Eckert III projection, high resolution',
  'World, Eckert III projection, low resolution',
  'World, Eckert III projection, medium resolution',
  'World, Miller projection, high resolution',
  'World, Miller projection, low resolution',
  'World Map', // The original name was `World, Miller projection, medium resolution`
  'World, Miller projection, ultra high resolution',
  'World, Miller projection, very high resolution',
  'World, Robinson projection, high resolution',
  'World, Robinson projection, low resolution',
  'World, Robinson projection, medium resolution',
  'Wyoming',
  'Yemen',
  'Yukon',
  'Zambia',
  'Zeeland',
  'Zimbabwe',
  'Zuid-Holland',
];
